import { AuditOperationCategories } from "helpers/enums/AuditOperationCategories";
import { IGetAuditLogs } from "interfaces/Audit/IGetAuditLogs";

export const auditApiBaseUrl = process.env.REACT_APP_API_BASE_URL!;

//Default get audit request
export const defaultGetAuditLogsQueryParams: IGetAuditLogs = {
  operationCategories: `${AuditOperationCategories.DetailsChange},${AuditOperationCategories.StatusChange},${AuditOperationCategories.LicenceChange},${AuditOperationCategories.OrganisationChange}`,
};
